<template>
  <div>
        <div v-if="step == 1">
            <div class="row">
                <div class="col-lg-7">
                    <h2 class="h1 mb-2 font-weight-normal">Chci zjistit více</h2>
                    <p class="mb-2">
                        Služba EUC Plus je zaměstnanecký benefit vhodný pro firmy všech velikostí. Maximální cena za zaměstnance je 199 Kč / měsíc.
                    </p>
                    <p>
                        Zanechte nám své kontaktní údaje a my se vám ozveme s podrobnější nabídkou.
                    </p>
                

                    <form action="#" method="POST" @submit.prevent="submit()">
                        <div class="mt-4">
                                    <div class="mb-3 custom-placeholder">
                                        <input type="text" id="company" class="form-control" v-model="formData.company" placeholder=" " required>
                                        <label class="label-floating" for="company">
                                            <span>
                                                Jméno firmy
                                            </span>
                                        </label>
                                    </div>
                                    <div class="mb-3 custom-placeholder">
                                        <input id="email" type="email" class="form-control" v-model="formData.email" placeholder=" " required>
                                        <label class="label-floating" for="email">
                                            <span>
                                                Váš e-mail
                                            </span>
                                        </label>
                                    </div>
                                    <div class="mt-3 text-right">
                                        <div class="w-75 w-sm-50 d-inline-block">
                                            <div class="mb-3">
                                                <button type="submit"
                                                    class="btn btn-secondary font-weight-light py-1 w-100"
                                                    :disabled="formSending"
                                                >
                                                    {{ formSending ? 'Odesílám...' : 'Odeslat' }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                        </div>
                    </form>
                </div>

                <div class="col-lg-5">

                </div>
            </div>

                <div class="col-12 bg-blue-bright py-4 py-md-5 mt-4">
                    <div class="row">
                        <div
                            class="col-lg-3 col-md-6 col-sm-12 text-white text-left text-md-center my-3 my-md-4 d-flex align-items-center d-md-block">
                            <svg class="icon-doctor mb-md-3 mr-3 mr-md-0 flex-shrink-0">
                                <use xlink:href="#icon-clock-back"></use>
                            </svg>
                            <p>
                                Ordinujeme 24&nbsp;hodin denně
                            </p>
                        </div>
                        <div
                            class="col-lg-3 col-md-6 col-sm-12 text-white text-left text-md-center my-3 my-md-4 d-flex align-items-center d-md-block">
                            <svg class="icon-doctor mb-md-3 mr-3 mr-md-0 flex-shrink-0">
                                <use xlink:href="#icon-mobile-solid"></use>
                            </svg>
                            <p>
                                Pohodlné objednání online
                            </p>
                        </div>
                        <div
                            class="col-lg-3 col-md-6 col-sm-12 text-white text-left text-md-center my-3 my-md-4 d-flex align-items-center d-md-block">
                            <svg class="icon-doctor mb-md-3 mr-3 mr-md-0 flex-shrink-0">
                                <use xlink:href="#icon-file-alt-regular"></use>
                            </svg>
                            <p>
                                Systém zdravotních benefitů
                            </p>
                        </div>
                        <div
                            class="col-lg-3 col-md-6 col-sm-12 text-white text-left text-md-center my-3 my-md-4 d-flex align-items-center d-md-block">
                            <svg class="icon-doctor mb-md-3 mr-3 mr-md-0 flex-shrink-0">
                                <use xlink:href="#icon-laptop-medical-regular"></use>
                            </svg>
                            <p>
                                Jednoduché uživatelské prostředí
                            </p>
                        </div>
                    </div>
                </div>

        </div>
        <div v-else>
            <div>
                <h2 class="h1 mb-2 font-weight-normal">Děkujeme</h2>
                <p>
                    Uvedenou firmu budeme kontaktovat a její zájem o produkt EUC Plus ověříme.
                </p>
                <div class="text-center mt-4">
                    <a href="#" class="btn btn-secondary font-weight-light py-1 px-5" data-dismiss="modal" aria-label="Close">Hotovo</a>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            // !!! if you are changing values below, change RESET values in mounted() as well
            step: 1,
            formSending: false,
            formData: {
                company: '',
                email: ''
            }
        }
    },
    mounted(){

        // focus fix for modal inputs
        let pageScroll = 0; 
        $("#modalEucPlus").on('show.bs.modal', () => {
        // when modal is opened, go to top of page
        pageScroll = $(window).scrollTop();
            window.scroll({
                top: 0
            }); 

        // push GA
        dataLayer.push({ 'event': 'virtualPageview', 'virtualPagePath': '/virtual/chci-euc-plus-formular', 'virtualPageTitle': 'Virtual - Chci EUC Plus formulář' });
        });
        $("#modalEucPlus").on('hide.bs.modal', () => {
            // when it's closed, return back
            window.scroll({
                top: pageScroll
            });
        });
        // --- focus fix for modal inputs ---

        $("#modalEucPlus").on('hidden.bs.modal', () => {
            // RESET form when modal is closed
            this.step = 1;
            this.formSending = false;
            this.formData = {
                company: '',
                email: ''
            }
        });

    },
    methods:{
        increseStep(){
            this.step++;
        },
        submit(){
            this.formSending = true;

            axios.post('/umbraco/api/eucplus/inquiry', {
                company: this.formData.company,
                email: this.formData.email
            }).then(response => {

                dataLayer.push({ 'event': 'ga.event', 'eventData': { 'category': 'Formular', 'action': 'Chci EUC Plus', 'label': 'Odeslan', 'value': 0 } });

                this.increseStep();
            }).catch(err => {
                console.error(err);
            }).finally(() => {
                this.formSending = false;

                // reset form data
                this.formData = {
                    company: '',
                    email: ''
                }
            });    
        }
    }
}
</script>